"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("./types");

var conditionsToActivitiesMap = {
  minClimb: 'climb',
  minDescent: 'descent',
  minPoints: 'points',
  minDuration: 'duration',
  minDistance: 'distance'
};

var getActivityProgressionForObjective = function getActivityProgressionForObjective(args) {
  var _objective$userAction;

  var objective = args.objective,
      activity = args.activity;
  var objectiveConditionKey;
  var isUserActionsObjective = !!((_objective$userAction = objective.userActionsTypes) === null || _objective$userAction === void 0 ? void 0 : _objective$userAction.length);

  for (var conditionKey in conditionsToActivitiesMap) {
    if (conditionKey in objective) {
      objectiveConditionKey = conditionKey;
    }
  }

  if (objectiveConditionKey || isUserActionsObjective) {
    var goal = objective.repeat || objective[objectiveConditionKey] || 0;
    var goalType = conditionsToActivitiesMap[objectiveConditionKey];

    var progressionValue = function (_objective$userAction2) {
      if (isUserActionsObjective && !((_objective$userAction2 = objective.userActionsTypes) === null || _objective$userAction2 === void 0 ? void 0 : _objective$userAction2.includes(_types.UserActionsType.BONUS_APPLIED))) {
        return (activity === null || activity === void 0 ? void 0 : activity.userActionsCount) || 0;
      }

      if (objective.repeat) {
        var _activity$activityIds;

        return (activity === null || activity === void 0 ? void 0 : (_activity$activityIds = activity.activityIds) === null || _activity$activityIds === void 0 ? void 0 : _activity$activityIds.length) || 0;
      }

      return (activity === null || activity === void 0 ? void 0 : activity[goalType]) || 0;
    }();

    var completionPercentage = Math.floor(progressionValue / goal * 100) || 0;
    return {
      value: Math.max(0, progressionValue),
      percentageCompleted: Math.min(Math.max(completionPercentage, 0), 100),
      goal: goal
    };
  }

  return {
    value: 0,
    percentageCompleted: 0,
    goal: 0
  };
};

var _default = getActivityProgressionForObjective;
exports["default"] = _default;
//# sourceMappingURL=getActivityProgressionForObjective.js.map